import React from 'react';
import { MenuIcon } from 'lucide-react';
import ThemeToggle from '../UI/ThemeToggle';
import { useTheme } from '../../context/ThemeContext';
interface HeaderProps {
  toggleSidebar: () => void;
}
const Header: React.FC<HeaderProps> = ({
  toggleSidebar
}) => {
  const {
    theme
  } = useTheme();
  return <header className={`flex items-center justify-between px-4 py-3 border-b ${theme === 'dark' ? 'bg-gray-800/80 border-gray-700 backdrop-blur-sm' : 'bg-white/80 border-gray-200 backdrop-blur-sm'}`} data-id="element-275">
      <div className="flex items-center" data-id="element-276">
        <button onClick={toggleSidebar} className={`p-2 rounded-md ${theme === 'dark' ? 'hover:bg-gray-700 text-gray-300' : 'hover:bg-gray-100 text-gray-600'}`} data-id="element-277">
          <MenuIcon size={20} data-id="element-278" />
        </button>
        <h1 className="ml-4 text-lg font-extralight tracking-wide" data-id="element-279">
          Scraper Monitoring System
        </h1>
      </div>
      <div className="flex items-center space-x-4" data-id="element-280">
        <ThemeToggle data-id="element-281" />
        <div className={`px-3 py-1 rounded-full text-sm font-extralight ${theme === 'dark' ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'}`} data-id="element-282">
          Last Updated: {new Date().toLocaleTimeString()}
        </div>
      </div>
    </header>;
};
export default Header;